import React from 'react';
import { Container } from '@/components/layout/Container';
import { Stack } from '@/components/layout/Stack';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { useNavigationStore } from '@/store/navigationStore';
import { User, Save } from 'lucide-react';

export function Profile() {
  const { setPageInfo } = useNavigationStore();

  // Set page info on mount
  React.useEffect(() => {
    setPageInfo('Profile');
  }, [setPageInfo]);

  return (
    <Container size="lg" className="py-6">
      <Stack spacing="lg">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Profile Info */}
          <Card className="lg:col-span-2">
            <CardHeader>
              <CardTitle>Personal Information</CardTitle>
              <CardDescription>
                Update your profile details and preferences
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Stack spacing="md">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="First Name"
                    defaultValue="John"
                    placeholder="Enter your first name"
                  />
                  <Input
                    label="Last Name"
                    defaultValue="Doe"
                    placeholder="Enter your last name"
                  />
                </div>
                
                <Input
                  label="Email Address"
                  type="email"
                  defaultValue="john.doe@example.com"
                  placeholder="Enter your email address"
                />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Job Title"
                    placeholder="Enter your job title"
                  />
                  <Input
                    label="Company"
                    placeholder="Enter your company"
                  />
                </div>

                <div className="pt-4">
                  <Button>
                    <Save className="h-4 w-4 mr-2" />
                    Save Changes
                  </Button>
                </div>
              </Stack>
            </CardContent>
          </Card>

          {/* Profile Picture & Stats */}
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>Profile Picture</CardTitle>
              </CardHeader>
              <CardContent>
                <Stack spacing="md" align="center">
                  <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center">
                    <User className="h-12 w-12 text-primary-foreground" />
                  </div>
                  <Button variant="outline" size="sm">
                    Upload New Photo
                  </Button>
                </Stack>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Account Stats</CardTitle>
              </CardHeader>
              <CardContent>
                <Stack spacing="sm">
                  <div className="flex justify-between">
                    <span className="text-sm text-muted-foreground">Aspirations</span>
                    <span className="text-sm font-medium">8</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-muted-foreground">Goals Achieved</span>
                    <span className="text-sm font-medium">18</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-muted-foreground">Lists Completed</span>
                    <span className="text-sm font-medium">28</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-muted-foreground">Member Since</span>
                    <span className="text-sm font-medium">Jan 2024</span>
                  </div>
                </Stack>
              </CardContent>
            </Card>
          </div>
        </div>
      </Stack>
    </Container>
  );
}